const config = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    API_BASE_URL_LOCATION: process.env.REACT_APP_API_BASE_URL_LOCATION,
    IMAGE_BASE_URL: process.env.REACT_APP_IMAGE_BASE_URL,
    IMAGE_BASE_URL_WITHOUT_UPLOAD: process.env.REACT_APP_IMAGE_BASE_URL_WITHOUT_UPLOAD,
  };
  
  export default config;
  